import { useCallback } from "react";
import { UpdateBrandDTO } from "@src/domain/dto/brands/UpdateBrand.dto";
import { UpdateBrandUseCase } from "@src/application/useCases/brand";
import { BrandRepository } from "@src/infrastructure/repositories/brand";
import { GraphQlAdapter } from "@src/infrastructure/adapters/graphQl/GraphQl.adapter";

export type UpdateBrandPayload = {
  brandId?: number | null;
  organizationId: number;
  organizationKey: string;
  brandKey: string;
  brandName: string;
  brandDisplayName: string;
  brandDescription?: string | null;
  brandIsActive: boolean;
  brandLogoFile?: File | null;
  brandLogoUrl?: string | null;
  brandLogoRemove?: boolean;
};

export function useUpdateBrand() {
  return useCallback(async (payload: UpdateBrandPayload) => {
    const validated = UpdateBrandDTO.validate(payload);
    if (!validated.success) {
      console.error("UpdateBrand validation failed", validated.error);
      throw new Error("Invalid brand data");
    }
    const dto = new UpdateBrandDTO(validated.data);
    return new UpdateBrandUseCase(
      new BrandRepository(GraphQlAdapter.getInstance().getClient()),
    ).execute(dto);
  }, []);
}
